<template>
    <el-select
        v-model="selectValue"
        :multiple="multiple"
        filterable
        style="width:100%;"
        remote
        :disabled="disabled"
        placeholder="请输入城市关键词"
        :remote-method="remoteMethod"
        :loading="loading"
        @clear="handleSelect"
        @change="handleSelect"
        :size="size"
    >
        <el-option-group
            v-for="group in options"
            :key="group.label"
            :label="group.label">
                <el-option v-for="item in group.options" :disabled="isNationwide(group.label)" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-option-group>
    </el-select>
</template>
<script>
import {fuzzyQueryCity} from '@/assets/js/commonApi';
export default {
    props: {
        value: {
            type: [Array, String],
            default: null
        },
        valueOptions: {
            type: Array,
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'medium'
        },
        defaultQuery: {
            type: String,
            default: ''
        },
        defaultQueryCallBack: Function,
        showNsationwide: { // 是否有全国选项
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            options: [{
                label: '全国',
                options: [{
                    value: '0',
                    label: '全国'
                }]
                }, {
                    label: '城市名',
                    options: []
                }
            ],
            selectValue: ''
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.selectValue = value;
            }
        },
        valueOptions: {
            immediate: true,
            handler(value) {
                if (value && value.length > 0) {
                    const options = [];
                    value.forEach(city => {if(city.value != 0) options.push(city)});
                    this.options[this.showNsationwide ? 1 : 0].options = options;
                }
            }
        },
        defaultQuery: {
            immediate: true,
            handler(value) {
                if(value) this.remoteMethod(value, (data) => {
                    this.selectValue = data;
                    this.$emit('update:value', this.selectValue);
                    if(this.defaultQueryCallBack) this.defaultQueryCallBack();
                });
            }
        },
        showNsationwide: {
            immediate: true,
            handler(value) {
                if(!value) this.options.splice(0, 1);
            }
        }
    },
    methods: {
        isNationwide (label) {
            if(label !== '城市名') return false;
            if(this.multiple && this.selectValue.findIndex(city => city == 0) !== -1) return true;
            return false;
        },
        handleSelect() {
            if(this.multiple && this.selectValue.findIndex(city => city == 0) !== -1) this.selectValue = ['0'];
            this.$emit('update:value', this.selectValue);
        },
        async remoteMethod(query, callBck) {
            if (query === '') return;
            this.loading = true;
            const response = await fuzzyQueryCity(query);
            const {msg, state, result} = response.data;
            this.loading = false;
            if (state != 1) return this.$message.error(msg);
            if (result && result.length > 0) {
                const options = result.map(city => {
                    return {
                        label: city.name,
                        value: city.code
                    };
                });
                this.options[this.showNsationwide ? 1 : 0].options = [...options, ...this.valueOptions];
                // 设置默认城市
                if(callBck) callBck(options[0].value);
            }
        }
    }
};
</script>
